import { render, staticRenderFns } from "./CheckVerifyToken.vue?vue&type=template&id=3868d76c"
import script from "./CheckVerifyToken.vue?vue&type=script&lang=js"
export * from "./CheckVerifyToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports